import { PublicRoutes } from '../../routes/navigation';

export const getSignInWidthLinkURL = (url: URL) => {
  const urlParams = url.searchParams;
  return `${PublicRoutes.SIGN_IN_BY_LINK_SUCCESS}?apiKey=${urlParams.get(
    'apiKey'
  )}&oobCode=${urlParams.get('oobCode')}&mode=signIn&lang=en`;
};
